import { deleteKicker, getKickers } from "api/kickers"
import React, { useState } from "react"
import { usePagination } from "hooks/usePagination"
import DeleteModal from "components/Common/DeleteModal"
import ResultHandler from "components/ResultHandler"
import PaginationHandler from "components/PaginationHandler"
import TableHeaderHandler from "components/TableHeaderHandler"
import { PERMISSIONS } from "api/permissions"
import { useTranslation } from "react-i18next"
import { useResponse } from "hooks/useResponse"
import TableAction from "components/TableAction"
import EmptyData from "components/EmptyData"
import { Table, Thead, Tbody, Td, Tr, Th } from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css"
import CustomImage from "components/CustomImage"

export default function KickersTable() {
  const { t } = useTranslation()

  const {
    response,
    loading,
    error,
    setPage,
    page,
    setPerPage,
    totalPages,
    setPayload,
  } = usePagination(getKickers)

  // delete

  const [show, setShow] = useState(false)

  function onCloseClick() {
    setShow(false)
  }

  const { setData } = useResponse(deleteKicker, () => {
    setShow(false)
    setPayload({ txt: "" })
  })

  const [deletingKicker, setDeletingKicker] = useState(null)

  function onDeleteClick() {
    setData({ type: "add", data: deletingKicker })
  }

  return (
    <>
      <TableHeaderHandler
        permission={PERMISSIONS.KICKER_CREATE}
        setPage={setPage}
        setPerPage={setPerPage}
        addUrl="/add-kicker"
      />
      <div className="table-rep-plugin">
        <div className="table-responsive">
          <Table className="table table-striped table-bordered">
            <Thead className="table-light table-nowrap">
              <Tr>
                <Th style={{ width: "20%" }}>{t("forms.Image")}</Th>
                <Th style={{ width: "40%" }}>{t("forms.Name")}</Th>
                <Th style={{ width: "20%" }}>{t("pages.Category")}</Th>
                <Th style={{ width: "30%", textAlign: "center" }}>
                  {t("tables.Action")}
                </Th>
              </Tr>
            </Thead>

            {response.data && !loading && (
              <Tbody>
                {response.data.kickers.map(row => {
                  return (
                    <Tr key={row.id}>
                      <Td>
                        {row.image_url ? (
                          <CustomImage
                            src={row.image_url}
                            className="rounded avatar-sm"
                            alt=""
                          />
                        ) : (
                          <div className="avatar-sm">
                            <span className="avatar-title rounded bg-primary text-white font-size-16">
                              {row.name.charAt(0)}
                            </span>
                          </div>
                        )}
                      </Td>
                      <Td>{row.name}</Td>
                      <Td>{row.Category.name}</Td>
                      <Td>
                        <TableAction
                          hasEdit={true}
                          hasDelete={true}
                          editPermission={PERMISSIONS.KICKER_EDIT}
                          deletePermission={PERMISSIONS.KICKER_DELETE}
                          type="kicker"
                          id={row.id}
                          setShow={setShow}
                          setDeleteIntitiy={setDeletingKicker}
                        />
                      </Td>
                    </Tr>
                  )
                })}
              </Tbody>
            )}
          </Table>

          {!loading && (
            <EmptyData
              empty={response.data && response.data.kickers.length === 0}
              msg="No Kickers Found."
            />
          )}
          <DeleteModal
            show={show}
            onDeleteClick={onDeleteClick}
            onCloseClick={onCloseClick}
          />

          {response.data && !loading && (
            <PaginationHandler
              page={page}
              setPage={setPage}
              totalPages={totalPages}
            />
          )}
          <ResultHandler error={error} loading={loading} />
        </div>
      </div>
    </>
  )
}
